export default __webpack_public_path__ + "static/media/wave-static-01.03335103.svg";